import { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import t from "../../../i18n/i18n";
import DefRoutes from "../../../routes/routes.json";
import useApi from "../../../services/api";
import { useSelector } from "react-redux";
import { useMemo } from "react";

function ExpiresInfo() {
  const { user } = useSelector((store) => store.auth);
  const date = useMemo(() => {
    if (!user) return null;

    const { loyal_member_expiration } = user;

    if (new Date() < new Date(loyal_member_expiration)) {
      return loyal_member_expiration;
    } else {
      return null;
    }
  }, []);

  return (
    <div className="expire-col">
      {date && (
        <>
          <p>
            <img src="images/time-loop.png" alt="" /> {t("LoyalMember.ExpiresIn")}{" "}
            <span>{moment(date).format("DD/MM/YYYY")}</span>
          </p>
          <Link to={DefRoutes.RechargeLoyalMember}>
            <img src={t("Images.A016")} alt="" />
          </Link>
        </>
      )}
    </div>
  );
}

export default ExpiresInfo;
